import React from 'react';

import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import './Css/themes/base/all.css';
import logo from '../logo.svg';
import '../App.css';
import './Css/trafico.css';
import './Css/controlDeviceResponsive.css';
import Menu from '../Modulos/Menu';
import Barra from '../Modulos/Barra';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import { FaFilter } from "@react-icons/all-files/fa/FaFilter";
import axios from '../utils/axiosConfig';
import { formattedGlobalDate } from './../utils/formattedDates';
import PreloaderHistorico from '../components/preloaders/preloader-historico';
import ModalBaseSm from '../components/modals/modal-base-sm';
import BaseModalCreateSolcitud from '../components/modals/baseModal';
import ModalCrearContratoControlDevice from '../components/modals/modalCrearContratoControlDevice';
import RSeguimientoServicio from '../components/modals/modalRSeguimientoServicio';
import FormReporteServicio from '../components/formsSolicitudes/formReporteServicio';
import FormUpdateContrato from '../components/formsSolicitudes/formUpdateContrato';
import FormUpdateContratoProyecto from '../components/formsSolicitudes/formUpdateContratoProyectos';
import { FaPlus, FaSyncAlt, FaEdit, FaEye } from 'react-icons/fa';
import Swal from 'sweetalert2';
import AgregarComandosModal from '../components/formsSolicitudes/AgregarComandosModal';
import checkPerm from '../utils/checkPerm';
import { registerOpenStreetMap } from '../utils/openStreetMapType';

var table;
let deviceValue = "";
var miStorage = window.localStorage;
class ControlDevice extends React.Component {

  constructor(props) {
    super(props);
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    deviceValue = params.get('device');
    if (deviceValue != null) {
      this.mapRef = React.createRef();
      this.mapCardRef = React.createRef();
      this.deviceMarker = null;
      this.markersById = {};
      this.routePolylines = [];
      this.infoWindow = null;
      this.ListarInfo = this.ListarInfo.bind(this);
      this.RenderMap = this.RenderMap.bind(this);
      this.state = {
        listInfo: [],
        InfoDevice: [],
        device: "",
        ultimocontrato: "",
        ultimaactualizacion: "",
        ultimoguardado: "",
        ultimaposicion: "",
        bateria: "",
        estado: "",
        servidor: "",
        apn1: "",
        lineaapn1: "",
        apn2: "",
        fw: "",
        tipo: "",
        esServidorJT: "",
        tipoEquipoLastServer: "",
        esServidorJTLastServer: "",
        ultServerLastServer: "",
        fechainicio: "",
        fechafin: "",
        maxDateDesde: '',
        minDateHasta: '',
        maxDateHasta: '',
        showPreloader: false,
        showModalCreateContract: false,
        showButtonModalCreateContract: false,
        showButtonAddCommand: false,
        showModalAddCommand: false,
        isDialogOpenEditContract: false,
        isDialogOpenRSeguimientoServicio: false,
        infoUpdateContrato: [],
        contratoseleccionado: '',
        dataGlobal: null,
        bitInsertMonitoreo: false,
        bitEditMonitoreo: false,
        estadoDevice: false,
        isMobileRealtimeOpen: false,
        isRealtimeSheetExpanded: false,
        isRealtimeSheetDragging: false,
        realtimeSheetDragOffset: 0,
        isAdditionalDeviceInfoVisible: false,
        isDeviceActionsMenuOpen: false,

      };
      this.ListarInfoDevice();
    } else {
      console.warn('El parámetro "device" no está presente en la URL');
      window.location = "/controldevices";
    }


  }

  componentDidUpdate(prevProps, prevState) {
    $('#search').keyup();

    if (prevState?.isMobileRealtimeOpen !== this.state.isMobileRealtimeOpen) {
      document.body.classList.toggle('controldevice-sheet-open', this.state.isMobileRealtimeOpen);
    }
  }
  componentDidMount() {
    document.body.classList.add('controldevice-responsive-page');
    window.addEventListener('keydown', this.handleRealtimeSheetKeyDown);
    $("#success-alert").hide();
    $("#danger-alert").hide();

    this.initializeMapWhenReady();

    $("#search").on("keyup", function () {
      var value = $(this).val().toLowerCase();
      $("#tabladata tr").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    });
    this.currentDate();
  }

  componentWillUnmount() {
    document.body.classList.remove('controldevice-responsive-page');
    document.body.classList.remove('controldevice-sheet-open');
    window.removeEventListener('keydown', this.handleRealtimeSheetKeyDown);
    window.clearTimeout(this.mapInitializationTimeout);
  }

  // Google Maps se carga de forma asíncrona desde index.html. En producción la
  // app puede montarse antes que el script; esperamos a la API en vez de
  // recargar toda la página (lo que antes producía un bucle de refresh).
  initializeMapWhenReady = (attempt = 0) => {
    const map = this.RenderMap();
    if (map) {
      this.pintarMarkerInfoDevice();
      return;
    }

    if (attempt < 40) {
      this.mapInitializationTimeout = window.setTimeout(
        () => this.initializeMapWhenReady(attempt + 1),
        250
      );
    }
  };

  RenderMap() {
    const google = window.google;
    const coords = { lat: 10.992716649650994, lng: -74.80259436365039 };
    const el = document.getElementById('map');

    if (!el || !google?.maps) {
      return null;
    }

    if (this.mapRef.current) return this.mapRef.current;

    try {
      this.mapRef.current = new google.maps.Map(el, {
        zoom: 16,
        fullscreenControl: false,
        center: coords,
      });
      registerOpenStreetMap(google, this.mapRef.current);
      return this.mapRef.current;
    } catch (error) {
      console.error('No fue posible inicializar Google Maps en Control Device:', error);
      return null;
    }

  }

  getDeviceCoords = (info = this.state?.InfoDevice?.[0]) => {
    if (!info) {
      return null;
    }

    const lat = Number(info.LastLatitude ?? info.latitude ?? info.Latitud ?? info.lat);
    const lng = Number(info.LastLongitude ?? info.longitude ?? info.Longitud ?? info.lng);

    if (Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0) {
      return { lat, lng };
    }

    return null;
  }

  pintarMarkerInfoDevice = (info = this.state?.InfoDevice?.[0]) => {
    const google = window.google;
    const coords = this.getDeviceCoords(info);

    if (!coords) {
      return;
    }

    const map = this.mapRef?.current || this.RenderMap();

    if (!map || !google?.maps) {
      return;
    }

    if (this.deviceMarker) {
      this.deviceMarker.setMap(null);
    }

    this.deviceMarker = new google.maps.Marker({
      position: coords,
      map,
      icon: this.buildMarkerIcon(info?.lock),
    });

    map.setCenter(coords);
    map.setZoom(16);
  }

  clearMapElements = () => {
    Object.values(this.markersById).forEach((marker) => marker?.setMap?.(null));
    this.markersById = {};

    this.routePolylines.forEach((polyline) => polyline?.setMap?.(null));
    this.routePolylines = [];

    if (this.infoWindow) {
      this.infoWindow.close();
    }
  }

  buildMarkerIcon = (lock) => ({
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
        <path d="M32 5C20 5 11 14 11 26c0 13 21 32 21 32s21-19 21-32C53 14 44 5 32 5Z" fill="#006699"/>
        <circle cx="32" cy="26" r="9" fill="#ffffff"/>
        <path d="M39 45v-4a4 4 0 0 0-8 0v4" fill="none" stroke="#00496f" stroke-width="2.5" stroke-linecap="round"/>
        <rect x="30" y="44" width="12" height="10" rx="1.5" fill="#00496f"/>
        ${lock === 0 ? '<path d="M33 44v-2a3 3 0 0 1 6 0v2" fill="none" stroke="#ffffff" stroke-width="1.8"/>' : ''}
        <circle cx="36" cy="49" r="1.3" fill="#ffffff"/>
      </svg>
    `)}`,
    scaledSize: new window.google.maps.Size(30, 30),
  })

  focusRowMarker = (item) => {
    const google = window.google;
    const lat = Number(item?.latitude);
    const lng = Number(item?.longitude);

    if (!Number.isFinite(lat) || !Number.isFinite(lng) || lat === 0 || lng === 0) {
      return;
    }

    const map = this.mapRef?.current || this.RenderMap();
    if (!map || !google?.maps) {
      return;
    }

    const markerKey = String(item?.ID ?? `${lat},${lng}`);
    let marker = this.markersById[markerKey];

    if (!marker) {
      marker = new google.maps.Marker({
        position: { lat, lng },
        map,
        id: item?.ID,
        icon: this.buildMarkerIcon(item?.lock),
      });
      this.markersById[markerKey] = marker;
    }

    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow();
    }

    const pointName = item?.Nombre || item?.position || 'Punto sin nombre';
    const pointDate = formattedGlobalDate(item?.UltActualizacion || item?.PositionTime || item?.eventDateTime);

    this.infoWindow.setContent(`
      <div>
        <div><strong>${pointName}</strong></div>
        <div>${pointDate}</div>
      </div>
    `);

    map.setCenter({ lat, lng });
    map.setZoom(19);
    this.infoWindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
  }


  // METODO PARA OBTENER LISTADO DE EVENTOS POR PROYECTO
  ListarInfo(limite = null) {
    this.setState({ listInfo: [] });
    const consultarHoy = limite !== null && limite !== undefined && Number(limite) === 0;
    let fechaInicio = this.state.fechainicio;
    let fechaFin = this.state.fechafin;

    if (consultarHoy) {
      const now = new Date();
      const fechaHoy = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      fechaInicio = `${fechaHoy}T00:00`;
      fechaFin = `${fechaHoy}T23:59`;

      this.setState({
        fechainicio: fechaInicio,
        fechafin: fechaFin,
        maxDateDesde: fechaInicio,
        minDateHasta: fechaInicio,
        maxDateHasta: fechaFin,
      });
    }

    let fi = new Date(fechaInicio);
    let ff = new Date(fechaFin);
    // console.log(fi);
    if (isNaN(fi) || isNaN(ff)) {
      $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
        $("#danger-alert").slideUp(2000);
      });
    } else {
      let fechainiciof = fi.getFullYear() + "-" + String(fi.getMonth() + 1).padStart(2, '0') + "-" + String(fi.getDate()).padStart(2, '0') + " " + String(fi.getHours()).padStart(2, '0') + ":" + String(fi.getMinutes()).padStart(2, '0') + ":00";
      let fechafinf = ff.getFullYear() + "-" + String(ff.getMonth() + 1).padStart(2, '0') + "-" + String(ff.getDate()).padStart(2, '0') + " " + String(ff.getHours()).padStart(2, '0') + ":" + String(ff.getMinutes()).padStart(2, '0') + ":00";
      let data =
      {
        "tipo": this.state.tipo,
        "device": deviceValue,
        "inicio": fechainiciof,
        "fin": fechafinf
      }

      if (limite !== null && limite !== undefined) {
        data.limite = Number(limite);
      }
      this.setState({ showPreloader: true });

      // console.log(data);
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/getreportescontroldevicexequipo', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(res => {
          if (res.data.success === false) {
            this.setState({ showPreloader: false });
            $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
              $("#danger-alert").slideUp(2000);
            });
          } else {
            this.setState({ listInfo: res.data.data, showPreloader: false }, () => {
              if (res.data.data && res.data.data.length > 0) {
                this.ListarInfoDevice();
              }
            });

            this.MarkersEnMapa(res.data.data);

            console.log("Data recibida info control device jejej:", res.data.data);
            //this.setState({ eventoseleccionado: res.data.data[0].ID_Evento });
          }
        }).catch((error) => {
          this.setState({ showPreloader: false });
          console.error(error);
        });
    }
  }

  handleCrearContrato = () => {
    // Lógica para crear contrato
    this.setState({ showModalCreateContract: true });
  }

  handleSubmitContract = (payload) => {
    console.log("Data recibida desde el modal para crear contrato:", payload);
    console.log("Device para crear contrato:", this.state.InfoDevice[0]);
    let data =
    {
      "tipoequipo": this.state.InfoDevice[0]?.FKLokTipoEquipo,
      "ubicacion": payload.ubicacion,
      "listaequipo": this.state.InfoDevice[0]?.DeviceID,
      "fechahora": payload.fechaLocal,
    }
    console.log("Data para crear contrato:", data);
    try {
      axios.post(process.env.REACT_APP_SERVER + '/contratos/crearcontrato', JSON.stringify(data), {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      }).then(res => {
        if (res.data.success === false) {
          $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
            $("#danger-alert").slideUp(2000);
          });
        } else {
          console.log("Contrato creado con éxito:", res.data);
          Swal.fire('success', "Contrato creado con éxito");
          this.setState({ showModalCreateContract: false });
          this.ListarInfoDevice();
        }
      })
    } catch (error) {
      Swal.fire('error', "No se pudo crear el contrato");
      console.error("Error al crear contrato:", error);
    }


  }

  onCloseModalCreateContract = () => {
    this.setState({ showModalCreateContract: false });
  }

  onCloseModalAddCommand = () => {
    this.setState({ showModalAddCommand: false });
  }

  onCloseEditContract = () => {
    this.setState({ isDialogOpenEditContract: false });
  }

  onCloseReporteServicio = () => {
    this.setState({ isDialogOpenRSeguimientoServicio: false });
  }

  getActiveContractData = () => {
    const info = this.state.InfoDevice?.[0] || {};
    const contractId = info.UltContrato || info.ContractID || info.LastContractID;

    if (!contractId || String(contractId).toLowerCase() === 'none') {
      Swal.fire({
        title: 'Información',
        text: 'El dispositivo no tiene un contrato activo asociado',
        icon: 'info',
        timer: 3000,
        showConfirmButton: false,
      });
      return null;
    }
    console.log("Información del contrato activo:", info, "ContractID:", contractId);
    return {
      ...info,
      ContractID: contractId,
      FKLokDeviceID: info.FKLokDeviceID || info.DeviceID || this.state.device,
    };
  }

  getPagePermissions = async (pagina) => {
    const res = await axios.post(
      process.env.REACT_APP_SERVER + '/usuarios/getconfiguracionpagina',
      JSON.stringify({ pagina }),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('tkn')}`,
        },
        withCredentials: true,
      }
    );

    if (res.data.success === false) {
      window.location = '/';
      return null;
    }

    return res.data?.data?.[0] || null;
  }

  showPermissionDenied = () => {
    Swal.fire({
      title: 'Información',
      text: 'No tiene los permisos necesarios para acceder a esta opción',
      icon: 'info',
      timer: 3000,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  }

  handleEditActiveContract = async () => {
    if (!this.canAccessActiveContractActions()) return;

    const contract = this.getActiveContractData();
    if (!contract) return;

    try {
      const permissions = await this.getPagePermissions('19');
      if (!permissions?.bitOpenActualizarContrato && !permissions?.bitOpen) {
        this.showPermissionDenied();
        return;
      }

      const project = localStorage.getItem('project');
      const endpoint = project === '1'
        ? '/contratos/getinfocontrato'
        : '/contratos/getinfocontratoproyecto';
      console.log("Endpoint para obtener información del contrato:", endpoint, "ContractID:", contract.ContractID);
      const resContrato = await axios.post(
        process.env.REACT_APP_SERVER + endpoint,
        JSON.stringify({ contrato: contract.ContractID }),
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('tkn')}`,
          },
          withCredentials: true,
        }
      );

      if (resContrato.data.success === false) {
        window.location = '/';
        return;
      }

      console.log("Información del contrato para edición:", resContrato.data.data);

      this.setState({
        dataGlobal: contract,
        infoUpdateContrato: resContrato.data.data || [],
        contratoseleccionado: contract.ContractID,
        isDialogOpenEditContract: true,
      });
    } catch (error) {
      console.error('Error al obtener la información del contrato:', error);
    }
  }

  handleOpenMonitoring = async () => {
    if (!this.canAccessActiveContractActions()) return;

    const contract = this.getActiveContractData();
    if (!contract) return;

    try {
      const permissions = await this.getPagePermissions('14');
      if (!permissions?.bitOpen) {
        this.showPermissionDenied();
        return;
      }

      this.setState({
        dataGlobal: contract,
        contratoseleccionado: contract.ContractID,
        bitInsertMonitoreo: permissions.bitInsert,
        bitEditMonitoreo: permissions.bitEdit,
        isDialogOpenRSeguimientoServicio: true,
      });
    } catch (error) {
      console.error('Error al validar permisos de monitoreo:', error);
    }
  }

  isDeviceInService = () => String(this.state.estado || '').trim().toLowerCase() === 'en servicio';

  canAccessActiveContractActions = () => {
    const info = this.state.InfoDevice?.[0] || {};
    const contractId = info.UltContrato || info.ContractID || info.LastContractID;
    const hasActiveContract =
      contractId &&
      String(contractId).trim().toLowerCase() !== 'none' &&
      info.Active !== false;

    return this.isDeviceInService() && hasActiveContract && info.Solicitud === null;
  }

  handleOpenAddCommand = async () => {
    await checkPerm('59', async () => {
      this.setState({ showModalAddCommand: true });
    });
  }

  getLastServerByDevice = async (deviceId) => {
    if (!deviceId) return;

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + '/operaciones/getlastserver',
        JSON.stringify({ device: deviceId }),
        {
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
          withCredentials: true
        }
      );
      console.log("Respuesta de operaciones/getlastserver:", res?.data);
      const payload = Array.isArray(res?.data?.data) ? res.data.data[0] : res?.data?.data;
      const tipoEquipo =
        payload?.FKLokTipoEquipo ??
        payload?.FKLopsTipoEquipo ??
        payload?.FkLopsTipoEquipo ??
        '';
      const esServidorJT =
        payload?.EsServidorJT ??
        payload?.esServidorJT ??
        payload?.es_servidor_jt ??
        '';
      const ultServer =
        payload?.UltServer ??
        payload?.ultServer ??
        payload?.ult_server ??
        '';

      this.setState({
        tipoEquipoLastServer: tipoEquipo,
        esServidorJTLastServer: esServidorJT,
        ultServerLastServer: ultServer,
        showButtonAddCommand: Number(tipoEquipo) === 9 && Number(esServidorJT) === 1,
      });
    } catch (error) {
      console.error('Error al consultar operaciones/getlastserver:', error);
      this.setState({
        tipoEquipoLastServer: '',
        esServidorJTLastServer: '',
        ultServerLastServer: '',
        showButtonAddCommand: false,
      });
    }
  }

  ListarInfoDevice() {
    this.setState({ InfoDevice: [] });
    let data =
    {
      "filtro": deviceValue
    }
    // console.log(data);
    const json = JSON.stringify(data);
    axios.post(process.env.REACT_APP_SERVER + '/operaciones/getreportescontroldeviceunico', json, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
      withCredentials: true
    })
      .then(res => {
        if (res.data.success === false) {
          window.location = "/";
        } else {
          console.log("Data recibida info device control device unico:", res.data.data);
          if (res.data.data && res.data.data.length > 0) {
            this.setState({ InfoDevice: res.data.data }, () => {
              this.pintarMarkerInfoDevice(res.data.data[0]);
              this.validateCrearContrato(res.data.data[0]);
            });
            if (Number(res.data.data[0]?.FKLokTipoEquipo) === 9) {
              this.getLastServerByDevice(deviceValue);
            } else {
              this.setState({
                tipoEquipoLastServer: '',
                esServidorJTLastServer: '',
                ultServerLastServer: '',
                showButtonAddCommand: false,
              });
            }
            this.setState({
              device: res.data.data[0].DeviceID, ultimocontrato: res.data.data[0].UltContrato,
              ultimaactualizacion: res.data.data[0].eventDateTime, ultimoguardado: res.data.data[0].LastSaved,
              ultimaposicion: res.data.data[0].Position, bateria: res.data.data[0].voltage,
              estado: res.data.data[0].Estado, servidor: res.data.data[0].UltServer,
              apn1: res.data.data[0].Apn1, lineaapn1: res.data.data[0].LApn1,
              apn2: res.data.data[0].Apn2, lineaapn2: res.data.data[0].LApn2,
              fw: res.data.data[0].FW,
              tipo: res.data.data[0].FKLokTipoEquipo,
              estadoDevice: res.data.data[0].Locked,
              esServidorJT: res.data.data[0].EsServidorJT ?? res.data.data[0].esServidorJT
            });
          } else {
            $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
              $("#danger-alert").slideUp(2000);
            });
            this.setState({ InfoDevice: [] });
          }
        }
      }).catch((error) => { console.error(error) });
  }

  //LIMPIAR FILTROS
  LimpiarFiltros = () => {
    this.setState({
      fechainicio: "",
      fechafin: "",
      maxDateDesde: '',
      minDateHasta: '',
      maxDateHasta: ''
    }, () => {
      this.currentDate();
    })
  }

  validateCrearContrato = (info) => {
    console.log("Esta es la info del device para validar:", info);
    if (info.IDEstado === 1 && (info.LastContractID === 'none' || info.Active === false)) {
      console.log("Mostrar botón para crear contrato");
      this.setState({ showButtonModalCreateContract: true });
    } else {
      this.setState({ showButtonModalCreateContract: false });
      console.log("No mostrar botón para crear contrato");
    }
  }



  MarkersEnMapa(lista) {
    const google = window.google;
    if (!google?.maps) return;
    this.clearMapElements();

    const promises = lista.filter(objeto => objeto.latitude !== 0 && objeto.longitude !== 0).map((objeto) => {
      return new Promise((resolve) => {
        resolve({ lat: objeto.latitude, lng: objeto.longitude, id: objeto.ID, icon: objeto.lock });
      });
    });
    Promise.all(promises)
      .then((flightPlanCoordinates) => {
        for (let i = 0; i < flightPlanCoordinates.length - 1; i++) {
          const directionArrow = new google.maps.Polyline({
            path: [flightPlanCoordinates[i + 1], flightPlanCoordinates[i]],
            geodesic: true,
            strokeColor: "#88A0CF",
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [
              {
                icon: {
                  path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                  scale: 1,
                  strokeColor: "#082357"
                },
                offset: "50%",
              },
            ],
            map: this.mapRef.current,
          });
          this.routePolylines.push(directionArrow);
        }

        const markerslist = flightPlanCoordinates.map((coordinate, index) => {
          const marker = new google.maps.Marker({
            position: coordinate,
            map: this.mapRef.current,
            id: coordinate.id,
            ubicacion: coordinate.ubicacion,
            icon: this.buildMarkerIcon(coordinate.icon),
          });

          this.markersById[String(coordinate.id)] = marker;

          return { marker };

        });

        const bounds = new google.maps.LatLngBounds();
        markerslist.forEach(({ marker }) => bounds.extend(marker.getPosition()));
        this.mapRef.current.fitBounds(bounds);
      });
  }

  currentDate = () => {
    const now = new Date();
    // Formatear la fecha para el campo de inicio (00:00)
    const currendDate = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, '0') + "-" + String(now.getDate()).padStart(2, '0') + "T00:00";
    this.setState({
      maxDateDesde: currendDate
    }
      // , () => { console.log("esta es la fecha actual: ", this.state.maxDateDesde) }
    );
  }

  handleInputChange = (event) => {
    // console.log(event);
    const fechaInicio = new Date(event);
    let inicio = fechaInicio.getFullYear() + "-" +
      String(fechaInicio.getMonth() + 1).padStart(2, '0') + "-" +
      String(fechaInicio.getDate()).padStart(2, '0') + "T00:00";
    // console.log("Inicio formateado:", inicio);
    let fin = fechaInicio.getFullYear() + "-" +
      String(fechaInicio.getMonth() + 1).padStart(2, '0') + "-" +
      String(fechaInicio.getDate()).padStart(2, '0') + "T23:59";
    // console.log("Fin formateado:", fin);

    this.setState({
      fechainicio: inicio,
      fechafin: fin
    })

  };

  getMobileDeviceStatus = (data = null) => {
    const serviceStatus = String(this.state.estado || '').trim();
    if (serviceStatus) return serviceStatus;
    return data?.lock ? 'Cerrado' : 'En Servicio';
  };

  handleRealtimeSheetKeyDown = (event) => {
    if (event.key === 'Escape' && this.state.isDeviceActionsMenuOpen) {
      this.setState({ isDeviceActionsMenuOpen: false });
      return;
    }

    if (event.key === 'Escape' && this.state.isMobileRealtimeOpen) {
      this.closeRealtimeSheet();
    }
  };

  toggleDeviceActionsMenu = () => {
    this.setState((prevState) => ({ isDeviceActionsMenuOpen: !prevState.isDeviceActionsMenuOpen }));
  };

  runDeviceAction = (action) => {
    this.setState({ isDeviceActionsMenuOpen: false }, action);
  };

  toggleRealtimeSheet = () => {
    this.setState((prevState) => ({
      isMobileRealtimeOpen: !prevState.isMobileRealtimeOpen,
      isRealtimeSheetExpanded: false,
      isRealtimeSheetDragging: false,
      realtimeSheetDragOffset: 0,
    }));
  };

  closeRealtimeSheet = () => {
    this.setState({
      isMobileRealtimeOpen: false,
      isRealtimeSheetExpanded: false,
      isRealtimeSheetDragging: false,
      realtimeSheetDragOffset: 0,
    });
  };

  handleRealtimeSheetDragStart = (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    this.realtimeSheetDrag = {
      pointerId: event.pointerId,
      startY: event.clientY,
      offset: 0,
    };
    event.currentTarget.setPointerCapture?.(event.pointerId);
    this.setState({ isRealtimeSheetDragging: true, realtimeSheetDragOffset: 0 });
  };

  handleRealtimeSheetDragMove = (event) => {
    if (!this.realtimeSheetDrag || this.realtimeSheetDrag.pointerId !== event.pointerId) return;

    const offset = event.clientY - this.realtimeSheetDrag.startY;
    this.realtimeSheetDrag.offset = offset;
    this.setState({ realtimeSheetDragOffset: Math.max(-140, Math.min(180, offset)) });
  };

  handleRealtimeSheetDragEnd = (event) => {
    if (!this.realtimeSheetDrag || this.realtimeSheetDrag.pointerId !== event.pointerId) return;

    const offset = this.realtimeSheetDrag.offset;
    const { isRealtimeSheetExpanded } = this.state;
    this.realtimeSheetDrag = null;
    if (event.currentTarget.hasPointerCapture?.(event.pointerId)) {
      event.currentTarget.releasePointerCapture(event.pointerId);
    }

    if (!isRealtimeSheetExpanded && offset <= -72) {
      this.setState({ isRealtimeSheetExpanded: true, isRealtimeSheetDragging: false, realtimeSheetDragOffset: 0 });
      return;
    }

    if (!isRealtimeSheetExpanded && offset >= 86) {
      this.closeRealtimeSheet();
      return;
    }

    this.setState({
      isRealtimeSheetExpanded: isRealtimeSheetExpanded && offset >= 86 ? false : isRealtimeSheetExpanded,
      isRealtimeSheetDragging: false,
      realtimeSheetDragOffset: 0,
    });
  };

  toggleAdditionalDeviceInfo = () => {
    this.setState((prevState) => ({
      isAdditionalDeviceInfoVisible: !prevState.isAdditionalDeviceInfoVisible,
    }));
  };

  toggleNavigationMenu = () => {
    document.querySelector('[class*="sidenav-toggle"]')?.click();
  };

  toggleMapFullscreen = () => {
    const mapCard = this.mapCardRef?.current;
    if (!mapCard) return;

    const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
    const requestFullscreen = mapCard.requestFullscreen || mapCard.webkitRequestFullscreen;
    const exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen;

    if (isFullscreen) {
      exitFullscreen?.call(document);
      return;
    }

    requestFullscreen?.call(mapCard);
  };

  getBatteryPercent = () => {
    const parsedBattery = Number.parseFloat(String(this.state.bateria ?? '').replace(',', '.'));
    if (!Number.isFinite(parsedBattery)) return null;
    return Math.max(0, Math.min(100, parsedBattery));
  };

  loadMobileData = () => {
    if (this.state.showPreloader) {
      return (
        <tr>
          <td colSpan="17" className="text-center">
            <PreloaderHistorico />
          </td>
        </tr>
      );
    }

    if (this.state.listInfo?.length === 0) {
      return (
        <tr>
          <td colSpan="17" className="text-center">
            <i className="bx bxs-spreadsheet bx-lg bx-tada-hover"></i>
            <p>No hay registros disponibles</p>
          </td>
        </tr>
      );
    }

    return this.state.listInfo.slice(0, 3).map((data) => {
      const hasCoords = Number(data.latitude) !== 0 && Number(data.longitude) !== 0;

      return (
        <tr
          key={`mobile-${data.ID}`}
          onClick={() => hasCoords && this.focusRowMarker(data)}
          style={{ cursor: hasCoords ? 'pointer' : 'default' }}
        >
          <td>{data.latitude}</td>
          <td>{data.longitude}</td>
          <td>{formattedGlobalDate(data.eventDateTime)}</td>
          <td>{formattedGlobalDate(data.UltActualizacion)}</td>
          <td>{data.DiffTime}</td>
          <td>{data.lock ? 'cerrado' : 'apertura'}</td>
          <td>{data.event}</td>
          <td>{data.device}</td>
          <td>{data.gpsStatus}</td>
          <td>{data.csq}</td>
          <td>{data.voltages}</td>
          <td>{data.speed}</td>
          <td>{data.Compania}</td>
          <td>{data.source}</td>
          <td>{data.servername}</td>
          <td>{data.position}</td>
          <td>{data.Nombre}</td>
        </tr>
      );
    });
  };

  loadRealtimeSheetData = () => {
    if (this.state.showPreloader) {
      return (
        <tr>
          <td colSpan="17" className="text-center"><PreloaderHistorico /></td>
        </tr>
      );
    }

    if (this.state.listInfo?.length === 0) {
      return (
        <tr>
          <td colSpan="17" className="text-center">
            <i className="bx bxs-spreadsheet bx-lg"></i>
            <p>No hay registros disponibles</p>
          </td>
        </tr>
      );
    }

    return this.state.listInfo.map((data) => {
      const hasCoords = Number(data.latitude) !== 0 && Number(data.longitude) !== 0;
      return (
        <tr
          key={`sheet-${data.ID}`}
          onClick={() => hasCoords && this.focusRowMarker(data)}
          style={{ cursor: hasCoords ? 'pointer' : 'default' }}
        >
          <td>{data.latitude}</td>
          <td>{data.longitude}</td>
          <td>{formattedGlobalDate(data.eventDateTime)}</td>
          <td>{formattedGlobalDate(data.UltActualizacion)}</td>
          <td>{data.DiffTime}</td>
          <td>{data.lock ? 'cerrado' : 'apertura'}</td>
          <td>{data.event}</td>
          <td>{data.device}</td>
          <td>{data.gpsStatus}</td>
          <td>{data.csq}</td>
          <td>{data.voltages}</td>
          <td>{data.speed}</td>
          <td>{data.Compania}</td>
          <td>{data.source}</td>
          <td>{data.servername}</td>
          <td>{data.position}</td>
          <td>{data.Nombre}</td>
        </tr>
      );
    });
  };

  renderRealtimeSheetCards = () => {
    if (this.state.showPreloader) {
      return <div className="controldevice-realtime-sheet-empty"><PreloaderHistorico /></div>;
    }

    if (!this.state.listInfo?.length) {
      return (
        <div className="controldevice-realtime-sheet-empty">
          <i className="bx bxs-spreadsheet bx-lg" aria-hidden="true"></i>
          <p>No hay registros disponibles</p>
        </div>
      );
    }

    return this.state.listInfo.map((data, index) => {
      const hasCoords = Number(data.latitude) !== 0 && Number(data.longitude) !== 0;
      const fields = [
        ['Latitud', data.latitude],
        ['Longitud', data.longitude],
        ['Últ. actualización', formattedGlobalDate(data.eventDateTime)],
        ['Últ. guardado', formattedGlobalDate(data.UltActualizacion)],
        ['Diferencia', data.DiffTime],
        ['Estado', data.lock ? 'Cerrado' : 'Apertura'],
        ['Evento', data.event],
        ['Device evento', data.device],
        ['GPS', data.gpsStatus],
        ['CSQ', data.csq],
        ['Batería', data.voltages],
        ['Velocidad', data.speed],
        ['Operador', data.Compania],
        ['Source', data.source],
        ['Servidor', data.servername],
        ['Últ. posición', data.position],
        ['Últ. geo', data.Nombre],
      ];

      return (
        <article
          className={`controldevice-realtime-record-card${hasCoords ? ' is-interactive' : ''}`}
          key={`sheet-card-${data.ID ?? index}`}
          onClick={() => hasCoords && this.focusRowMarker(data)}
          onKeyDown={(event) => {
            if (hasCoords && (event.key === 'Enter' || event.key === ' ')) {
              event.preventDefault();
              this.focusRowMarker(data);
            }
          }}
          role={hasCoords ? 'button' : undefined}
          tabIndex={hasCoords ? 0 : undefined}
        >
          <header>
            <div>
              <strong>Registro {index + 1}</strong>
              <span>{formattedGlobalDate(data.eventDateTime) || 'Sin fecha registrada'}</span>
            </div>
            {hasCoords && <i className="bx bx-map-pin" aria-hidden="true"></i>}
          </header>
          <div className="controldevice-realtime-record-fields">
            {fields.map(([label, value]) => (
              <div className="controldevice-realtime-record-field" key={label}>
                <span>{label}</span>
                <strong>{value === null || value === undefined || value === '' ? '—' : value}</strong>
              </div>
            ))}
          </div>
        </article>
      );
    });
  };

  renderDeviceInfo = () => {
    const batteryPercent = this.getBatteryPercent();
    const batteryLabel = batteryPercent === null ? (this.state.bateria || '—') : `${batteryPercent}%`;
    const deviceInfo = this.state.InfoDevice?.[0] || {};
    const proyecto = deviceInfo.proyecto ?? deviceInfo.Proyecto ?? deviceInfo.NombreProyecto ?? deviceInfo.DescripcionProyecto ?? deviceInfo.FKLokProyecto;
    const agencia = deviceInfo.agencia ?? deviceInfo.Agencia ?? deviceInfo.NombreAgencia ?? deviceInfo.DescripcionAgencia ?? deviceInfo.FKAgencia;
    const infoItems = [
      { icon: 'bx-id-card', label: 'DeviceID:', value: this.state.device },
      { icon: 'bx-file', label: 'Ul.Contrato:', value: this.state.ultimocontrato },
      { icon: 'bx-briefcase', label: 'Proyecto:', value: proyecto },
      { icon: 'bx-building', label: 'Agencia:', value: agencia },
      { icon: 'bx-time-five', label: 'Ul.Actualización:', value: formattedGlobalDate(this.state.ultimaactualizacion) },
      { icon: 'bx-calendar-check', label: 'Ul.Guardado:', value: formattedGlobalDate(this.state.ultimoguardado) },
      {
        icon: 'bx-battery',
        label: 'Batería:',
        value: (
          <span className="controldevice-battery-value">
            <span>{batteryLabel}</span>
            {batteryPercent !== null && (
              <span
                className="controldevice-battery-progress"
                role="progressbar"
                aria-label={`Nivel de batería: ${batteryLabel}`}
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow={batteryPercent}
              >
                <span style={{ width: `${batteryPercent}%` }}></span>
              </span>
            )}
          </span>
        ),
      },
      { icon: 'bx-map', label: 'Ul.Posición:', value: this.state.ultimaposicion },
      {
        icon: 'bx-check-circle',
        label: 'Estado:',
        value: (
          <span className="controldevice-service-status">
            <span className="controldevice-service-status-dot" aria-hidden="true"></span>
            {this.state.estado || 'En Servicio'}
          </span>
        ),
      },
      { icon: 'bx-server', label: 'Servidor:', value: this.state.servidor },
      { icon: 'bx-wifi', label: 'APN Principal:', value: this.state.apn1 },
      { icon: 'bx-mobile', label: 'Línea APN Ppal:', value: this.state.lineaapn1 },
      { icon: 'bx-wifi-2', label: 'APN Secundaria:', value: this.state.apn2 },
      { icon: 'bx-mobile', label: 'Línea APN Sec:', value: this.state.lineaapn2 },
      { icon: 'bx-chip', label: 'Firmware:', value: this.state.fw },
      {
        icon: this.state.estadoDevice ? 'bx-lock' : 'bx-lock-open-alt',
        label: 'Estado Device:',
        value: (
          <span className="controldevice-lock-value">
            <img
              src={this.state.estadoDevice ? "/images/closedpadlock.png" : "/images/openedpadlock.png"}
              alt={this.state.estadoDevice ? "Dispositivo cerrado" : "Dispositivo abierto"}
              title={this.state.estadoDevice ? "Dispositivo cerrado" : "Dispositivo abierto"}
              width="22"
              height="22"
            />
            <span>{this.state.estadoDevice ? "Cerrado" : "Abierto"}</span>
          </span>
        ),
      },
    ];

    return infoItems.map((item, index) => (
      <div
        className={`controldevice-info-item${index > 8 ? ' controldevice-info-item--additional' : ''}`}
        key={item.label}
      >
        <div className="controldevice-info-label">
          <i className={`bx ${item.icon}`} aria-hidden="true"></i>
          <b>{item.label}</b>
        </div>
        <div className="controldevice-info-value">{item.value ?? '—'}</div>
      </div>
    ));
  };


  render() {
    return (
      <>
        <div className="layout-wrapper layout-content-navbar controldevice-page">
          <div className="layout-container">


            <div className="layout-page">
              <Barra onToggleNavigation={this.toggleNavigationMenu} />
              <div className="content-wrapper">

                <div className="container-fluid flex-grow-1 container-p-y">
                  <MDBRow className="controldevice-header-row">
                    <MDBCol md='7' className="controldevice-title-col">
                      <div className="controldevice-title-line">
                        <h4 className="fw-bold mb-4 controlDeviceTitle">Control Device</h4>
                      </div>
                    </MDBCol>
                    <MDBCol md='5' className="controldevice-toolbar-col">
                      <div className="d-flex align-items-center gap-2 w-100" style={{ height: '36px' }}>
                        <div className="input-group flex-grow-1" style={{ height: '36px', minHeight: '36px', maxHeight: '36px', boxSizing: 'border-box' }}>
                          <span className="input-group-text" id="b1" style={{ height: '36px', minHeight: '36px', maxHeight: '36px', padding: '0 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box' }}><FaSearch /></span>
                          <input id="search" type="text" className="form-control" placeholder="Filtrar dispositivo..." aria-describedby="b1" style={{ height: '36px', minHeight: '36px', maxHeight: '36px', padding: '0 12px', lineHeight: 1.5, boxSizing: 'border-box' }}
                          />
                        </div>
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasEnd"
                          aria-controls="offcanvasEnd"
                          title="Abrir filtros"
                          aria-label="Abrir filtros"
                          style={{
                            width: '46px',
                            height: '36px',
                            minHeight: '36px',
                            maxHeight: '36px',
                            flex: '0 0 46px',
                            boxSizing: 'border-box',
                            padding: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: 1,
                            borderRadius: '0.375rem',
                          }}
                        >
                          <FaFilter />
                        </button>
                        <button
                          className="btn"
                          type="button"
                          onClick={() => this.ListarInfo(0)}
                          title="Consultar los últimos 50 reportes"
                          aria-label="Consultar los últimos 50 reportes"
                          style={{
                            width: '36px',
                            height: '36px',
                            minHeight: '36px',
                            maxHeight: '36px',
                            padding: 0,
                            boxSizing: 'border-box',
                            border: 'none',
                            borderRadius: '50%',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: '0 0 36px',
                            backgroundColor: '#82bd3f',
                            color: '#fff',
                            boxShadow: '0 4px 10px rgba(91, 143, 31, 0.28)',
                          }}
                        >
                          <FaSyncAlt size={15} />
                        </button>
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="controldevice-overview-row">
                    <MDBCol md='7' className="controldevice-info-col">
                      <div className="controldevice-information-card">
                        <div className="controldevice-section-heading">
                          <i className="bx bx-devices" aria-hidden="true"></i>
                          <span>Información del dispositivo</span>
                          {(this.state.showButtonAddCommand || this.canAccessActiveContractActions()) && (
                            <button type="button" className="controldevice-more-button" onClick={this.toggleDeviceActionsMenu} aria-label="Más opciones del dispositivo" aria-haspopup="menu" aria-expanded={this.state.isDeviceActionsMenuOpen}>•••</button>
                          )}
                        </div>
                        {this.state.isDeviceActionsMenuOpen && (this.state.showButtonAddCommand || this.canAccessActiveContractActions()) && (
                          <div className="controldevice-actions-popover" role="menu" aria-label="Acciones del dispositivo">
                            {this.state.showButtonAddCommand && (
                              <button type="button" role="menuitem" onClick={() => this.runDeviceAction(this.handleOpenAddCommand)}>
                                <i className="bx bx-terminal" aria-hidden="true"></i>
                                Agregar comando
                              </button>
                            )}
                            {this.canAccessActiveContractActions() && (
                              <>
                                <button type="button" role="menuitem" onClick={() => this.runDeviceAction(this.handleEditActiveContract)}>
                                  <FaEdit aria-hidden="true" />
                                  Editar contrato
                                </button>
                                <button type="button" role="menuitem" onClick={() => this.runDeviceAction(this.handleOpenMonitoring)}>
                                  <FaEye aria-hidden="true" />
                                  Abrir monitoreo
                                </button>
                              </>
                            )}
                          </div>
                        )}
                        <div
                          id="controldevice-additional-info"
                          className={`controldevice-info-grid${this.state.isAdditionalDeviceInfoVisible ? ' is-expanded' : ''}`}
                        >
                          {this.renderDeviceInfo()}
                        </div>
                        <button
                          type="button"
                          className="controldevice-additional-info-toggle"
                          onClick={this.toggleAdditionalDeviceInfo}
                          aria-controls="controldevice-additional-info"
                          aria-expanded={this.state.isAdditionalDeviceInfoVisible}
                        >
                          <span>{this.state.isAdditionalDeviceInfoVisible ? 'Mostrar menos información' : 'Mostrar más información'}</span>
                          <i
                            className={`bx ${this.state.isAdditionalDeviceInfoVisible ? 'bx-chevron-up' : 'bx-chevron-down'}`}
                            aria-hidden="true"
                          ></i>
                        </button>
                      {this.state.showButtonModalCreateContract && (
                        <MDBRow className="mt-3 controldevice-action-row">
                          <MDBCol md="5">
                            <button
                              className="btn-primary-modals-maestros btn-pulse d-inline-flex align-items-center justify-content-center gap-2 lh-1 crearContratoControlDevice"
                              type="button"
                              onClick={this.handleCrearContrato}
                            >
                              <FaPlus size={18} />
                              <span>Crear Contrato</span>
                            </button>
                          </MDBCol>
                        </MDBRow>
                      )}
                      {this.state.showButtonAddCommand && (
                        <MDBRow className="mt-3 controldevice-action-row controldevice-inline-actions">
                          <MDBCol md="5">
                            <button
                              className="btn-primary-modals-maestros d-inline-flex align-items-center justify-content-center gap-2 lh-1 crearContratoControlDevice"
                              type="button"
                              onClick={this.handleOpenAddCommand}
                            >
                              <FaPlus size={18} />
                              <span>Agregar comando</span>
                            </button>
                          </MDBCol>
                        </MDBRow>
                      )}
                      {this.canAccessActiveContractActions() && (
                        <MDBRow className="mt-3 controldevice-action-row controldevice-inline-actions">
                          <MDBCol md="auto" className="d-flex flex-wrap gap-2">
                            <button
                              className="btn-primary-modals-maestros d-inline-flex align-items-center justify-content-center gap-2 lh-1 crearContratoControlDevice"
                              type="button"
                              onClick={this.handleEditActiveContract}
                              title="Editar contrato"
                            >
                              <FaEdit size={16} />
                              <span>Editar contrato</span>
                            </button>
                            <button
                              className="btn-primary-modals-maestros d-inline-flex align-items-center justify-content-center gap-2 lh-1 crearContratoControlDevice"
                              type="button"
                              onClick={this.handleOpenMonitoring}
                              title="Abrir monitoreo"
                            >
                              <FaEye size={16} />
                              <span>Abrir monitoreo</span>
                            </button>
                          </MDBCol>
                        </MDBRow>
                      )}
                      </div>
                    </MDBCol>
                    <MDBCol md='5' className="controldevice-map-col">
                      <div className="controldevice-map-card" ref={this.mapCardRef}>
                        <div className="controldevice-section-heading">
                          <i className="bx bx-map-pin" aria-hidden="true"></i>
                          <span>Ubicación del dispositivo</span>
                        </div>
                        <div id="map" />
                        <button
                          type="button"
                          className="controldevice-map-fullscreen-button"
                          onClick={this.toggleMapFullscreen}
                          aria-label="Ver mapa en pantalla completa"
                          title="Pantalla completa"
                        >
                          ⛶
                        </button>
                      </div>
                    </MDBCol>
                  </MDBRow>

                  <div className="card cardControlDevice controldevice-realtime-card" style={{ marginTop: '15px' }}>
                    <div className="controldevice-section-heading controldevice-realtime-heading">
                      <i className="bx bx-bar-chart-alt-2" aria-hidden="true"></i>
                      <span>Datos en tiempo real</span>
                      <button
                        type="button"
                        className="controldevice-realtime-open"
                        onClick={this.toggleRealtimeSheet}
                        aria-label="Abrir datos en tiempo real"
                        aria-expanded={this.state.isMobileRealtimeOpen}
                      >
                        <i className="bx bx-chevron-right" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="table-responsive text-nowrap controldevice-desktop-table" style={{ height: '300px', overflowY: "auto", display: "flex", flexDirection: "column", overflowX: 'auto' }}>
                      <table className="table table-hover" id="tabla" style={{ tableLayout: 'auto', fontSize: '12px' }}>
                        <thead className="FondoHeaderTabla2">
                          <tr>
                            <th style={{ color: '#ffffff' }}>Latitud</th>
                            <th style={{ color: '#ffffff' }}>Longitud</th>
                            <th style={{ color: '#ffffff' }}>Ul.Actualizacion</th>
                            <th style={{ color: '#ffffff' }}>Ul.Guardado</th>
                            <th style={{ color: '#ffffff' }}>Diff</th>
                            <th style={{ color: '#ffffff' }}>Estado</th>
                            <th style={{ color: '#ffffff' }}>Evento</th>
                            <th style={{ color: '#ffffff' }}>DeviceEvento</th>
                            <th style={{ color: '#ffffff' }}>Gps</th>
                            <th style={{ color: '#ffffff' }}>CSQ</th>
                            <th style={{ color: '#ffffff' }}>Bateria</th>
                            <th style={{ color: '#ffffff' }}>Vel.</th>
                            <th style={{ color: '#ffffff' }}>Operador</th>
                            <th style={{ color: '#ffffff' }}>Source</th>
                            <th style={{ color: '#ffffff' }}>Server</th>
                            <th style={{ color: '#ffffff' }}>Ul.Posicion</th>
                            <th style={{ color: '#ffffff' }}>Ul.Geo</th>
                          </tr>
                        </thead>
                        <tbody className="table-border-bottom-0" id="tabladata">
                          {this.loadFillData([])}
                        </tbody>
                      </table>
                    </div>
                    <div className="controldevice-mobile-table-wrap">
                      <table className="table table-hover controldevice-mobile-table" aria-label="Datos en tiempo real">
                        <thead className="FondoHeaderTabla2">
                          <tr>
                            <th>LATITUD</th>
                            <th>LONGITUD</th>
                            <th>UL.ACTUALIZACION</th>
                            <th>UL.GUARDADO</th>
                            <th>DIFF</th>
                            <th>ESTADO</th>
                            <th>EVENTO</th>
                            <th>DEVICE EVENTO</th>
                            <th>GPS</th>
                            <th>CSQ</th>
                            <th>BATERIA</th>
                            <th>VEL.</th>
                            <th>OPERADOR</th>
                            <th>SOURCE</th>
                            <th>SERVER</th>
                            <th>UL.POSICION</th>
                            <th>UL.GEO</th>
                          </tr>
                        </thead>
                        <tbody>{this.loadMobileData()}</tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="content-backdrop fade"></div>
              </div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
        </div>

        {this.state.isMobileRealtimeOpen && (
          <div
            className="controldevice-realtime-sheet-backdrop"
            role="presentation"
            onClick={this.closeRealtimeSheet}
          >
            <section
              className={`controldevice-realtime-sheet${this.state.isRealtimeSheetExpanded ? ' is-expanded' : ''}${this.state.isRealtimeSheetDragging ? ' is-dragging' : ''}`}
              role="dialog"
              aria-modal="true"
              aria-labelledby="controldevice-realtime-sheet-title"
              style={{ transform: `translateY(${this.state.realtimeSheetDragOffset}px)` }}
              onClick={(event) => event.stopPropagation()}
            >
              <div
                className="controldevice-realtime-sheet-handle"
                role="presentation"
                onPointerDown={this.handleRealtimeSheetDragStart}
                onPointerMove={this.handleRealtimeSheetDragMove}
                onPointerUp={this.handleRealtimeSheetDragEnd}
                onPointerCancel={this.handleRealtimeSheetDragEnd}
              >
                <span aria-hidden="true"></span>
              </div>
              <header className="controldevice-realtime-sheet-header">
                <div>
                  <strong id="controldevice-realtime-sheet-title">Datos en tiempo real</strong>
                  <span>Consulta la información completa de cada registro</span>
                </div>
                <button type="button" onClick={this.toggleRealtimeSheet} aria-label="Cerrar datos en tiempo real">×</button>
              </header>
              <div className="controldevice-realtime-sheet-body">
                <div className="controldevice-realtime-sheet-records">
                  {this.renderRealtimeSheetCards()}
                </div>
                <div className="controldevice-realtime-sheet-table-wrap">
                  <table className="table table-hover controldevice-realtime-sheet-table">
                    <thead className="FondoHeaderTabla2">
                      <tr>
                        <th>LATITUD</th>
                        <th>LONGITUD</th>
                        <th>UL.ACTUALIZACIÓN</th>
                        <th>UL.GUARDADO</th>
                        <th>DIFF</th>
                        <th>ESTADO</th>
                        <th>EVENTO</th>
                        <th>DEVICEVENTO</th>
                        <th>GPS</th>
                        <th>CSQ</th>
                        <th>BATERÍA</th>
                        <th>VEL.</th>
                        <th>OPERADOR</th>
                        <th>SOURCE</th>
                        <th>SERVER</th>
                        <th>UL.POSICIÓN</th>
                        <th>UL.GEO</th>
                      </tr>
                    </thead>
                    <tbody>{this.loadRealtimeSheetData()}</tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        )}

        <div className="alert alert-success" id="success-alert">
          <strong>Exitoso! </strong> Los cambios han sido realizados con exito.
        </div>

        <div className="alert alert-danger" id="danger-alert">
          <strong>Error! </strong> Se ha presentado un error, valide la información.
        </div>

        <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="offcanvasEnd" aria-labelledby="offcanvasScrollingLabel">
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasScrollingLabel">Filtros</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <div className="row">
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <label>Hora/Fecha Inicio:</label>
                  <input type="datetime-local" className="form-control" style={{ width: '88%' }}
                    value={this.state.fechainicio}
                    max={this.state.maxDateDesde}
                    onChange={(e) => this.handleInputChange(e.target.value)} />
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <label>Hora/Fecha Fin:</label>
                  <input type="datetime-local" className="form-control" style={{ width: '88%' }}
                    value={this.state.fechafin}
                    min={this.state.minDateHasta}
                    max={this.state.maxDateHasta}
                    disabled
                  // onChange={e => this.handleInputChange(e, 'fechafin')} 
                  />
                </div>
              </div>

              <div className="mb-3 d-flex flex-column align-items-end">
                <button type="button" className="btn btn-outline-secondary justify-content-end" onClick={() => this.ListarInfo()} data-bs-dismiss="offcanvas">
                  <span className="tf-icons bx bx-search"></span>&nbsp; Consultar
                </button>
              </div>

            </div>
          </div>
        </div>

        <ModalBaseSm
          isOpen={this.state.showModalCreateContract}
          title={"Crear Contrato"}
          onClose={this.onCloseModalCreateContract}
          childComponent={
            <ModalCrearContratoControlDevice
              onClose={() => this.setState({ showModalCreateContract: false })}
              setDataSaving={this.handleSubmitContract}
            />
          }
        />

        <BaseModalCreateSolcitud
          isOpen={this.state.isDialogOpenEditContract}
          title="Actualizar contrato"
          onClose={this.onCloseEditContract}
          childComponent={localStorage.getItem('project') === '1' ? (
            <FormUpdateContrato
              contrato={this.state.contratoseleccionado}
              info={this.state.infoUpdateContrato}
              sourceContract={this.state.dataGlobal}
              onClose={this.onCloseEditContract}
              onSaved={() => this.ListarInfoDevice()}
            />
          ) : (
            <FormUpdateContratoProyecto
              contrato={this.state.contratoseleccionado}
              info={this.state.infoUpdateContrato}
              sourceContract={this.state.dataGlobal}
              onClose={this.onCloseEditContract}
              onSaved={() => this.ListarInfoDevice()}
            />
          )}
        />

        <RSeguimientoServicio
          isOpen={this.state.isDialogOpenRSeguimientoServicio}
          title="Monitoreo de tráfico"
          onClose={this.onCloseReporteServicio}
          childComponent={
            <FormReporteServicio
              contrato={this.state.contratoseleccionado}
              images={() => { }}
              tracking={() => { }}
              consolidado={() => { }}
              bitInsert={this.state.bitInsertMonitoreo}
              bitEdit={this.state.bitEditMonitoreo}
            />
          }
        />

        <AgregarComandosModal
          isOpen={this.state.showModalAddCommand}
          onClose={this.onCloseModalAddCommand}
          contratoInfo={{
            FKLokDeviceID: this.state.device || deviceValue,
            UltServer: this.state.ultServerLastServer || this.state.servidor,
            FKLokTipoEquipo: this.state.tipoEquipoLastServer || this.state.tipo,
            EsServidorJT: this.state.esServidorJTLastServer || this.state.esServidorJT,
          }}
        />

      </>


    );
  }

  loadFillData(array) {


    if (this.state.showPreloader) {
      return (
        <>
          <tr>
            <td colSpan="16" className="text-center">
              <PreloaderHistorico />
            </td>
          </tr>
        </>
      )
    }

    if (this.state.listInfo?.length === 0) {
      return (
        <tr>
          <td colSpan="16" className="text-center">
            <i className='bx bxs-spreadsheet bx-lg bx-tada-hover'></i>
            <p>No hay registros disponibles</p>
          </td>
        </tr>
      )
    }

    console.log("LISTINFOOOOO:", this.state.listInfo);
    return this.state.listInfo?.map((data) => {
      const hasCoords = Number(data.latitude) !== 0 && Number(data.longitude) !== 0;

      return (
        <tr
          key={data.ID}
          onClick={() => hasCoords && this.focusRowMarker(data)}
          style={{ cursor: hasCoords ? 'pointer' : 'default' }}
        >
          <td>{data.latitude}</td>
          <td>{data.longitude}</td>
          <td>{formattedGlobalDate(data.eventDateTime)}</td>
          <td>{formattedGlobalDate(data.UltActualizacion)}</td>
          <td>{data.DiffTime}</td>
          <td>{data.lock ? 'cerrado' : 'apertura'}</td>
          <td>{data.event}</td>
          <td>{data.device}</td>
          <td>{data.gpsStatus}</td>
          <td>{data.csq}</td>
          <td>{data.voltages}</td>
          <td>{data.speed}</td>
          <td>{data.Compania}</td>
          <td>{data.source}</td>
          <td>{data.servername}</td>
          <td>{data.position}</td>
          <td>{data.Nombre}</td>
        </tr>
      )
    });
    $('.dropdown-toggle').dropdown();

  }
}

export default ControlDevice;
